import React from "react";
import { useTranslation } from "react-i18next";

import { Tag, TagLabel } from "@chakra-ui/react";

import { ClaimType } from "models/Claim";

type IComponent = {
  claimType: ClaimType;
};

const ClaimTypeTag: React.FC<IComponent> = ({ claimType }) => {
  const { t } = useTranslation();
  const bgColor = claimType === "cancelled" ? "danger.200" : "warning.200";
  const textColor = claimType === "cancelled" ? "danger.500" : "warning.500";

  return (
    <Tag borderRadius="full" variant="solid" color={textColor} bgColor={bgColor} fontSize="10px" size="sm" py={2}>
      <TagLabel>{t(`claim_card.disruption_type.${claimType}`)}</TagLabel>
    </Tag>
  );
};

export default ClaimTypeTag;
